import useWindowDimensions from 'utils/WindowDimensions';
import { ProblemsSolvedAccordion } from './ProblemsSolvedAccordion';
import { ProblemsSolvedGrid } from './ProblemsSolvedGrid';

const MOBILE_DESIGN_THRESHOLD = 1100;

type SolutionsProps = {
  solutions: {
    heading: string;
    problemText: string;
    solutionText: string;
  }[];
};

export const Solutions = ({ solutions }: SolutionsProps) => {
  const { width } = useWindowDimensions();

  return width >= MOBILE_DESIGN_THRESHOLD ? (
    <ProblemsSolvedGrid problemsSolved={solutions} />
  ) : (
    <ProblemsSolvedAccordion problemsSolved={solutions} />
  );
};
